import gql from 'graphql-tag';
import { client } from '../../..';
import { CannedNote, CannedNoteData, mapCannedNotes } from './cannedNotes';

interface CannedNotesQueryData {
    lookup: {
        cannedNotes: CannedNoteData[];
    };
}

// Network first: the notes are asked for from the server every time the enquiry loads (they are edited in the Canned notes lookup), and the answer is
// kept in Apollo's cache. If the network fails, whatever the cache holds from an earlier load is used instead.
export const retrieveCannedNotes = async (actionTypeGuid?: string): Promise<CannedNote[]> => {
    const variables = { actionTypeGuid: actionTypeGuid || null };
    try {
        const results = await client.query<CannedNotesQueryData>({ query: CannedNotesQuery, variables, fetchPolicy: 'network-only' });
        return mapCannedNotes(results.data.lookup.cannedNotes);
    } catch (networkError) {
        const cachedResults = await client.query<CannedNotesQueryData>({ query: CannedNotesQuery, variables, fetchPolicy: 'cache-only' }).catch(() => null);
        if (cachedResults && cachedResults.data && cachedResults.data.lookup) {
            return mapCannedNotes(cachedResults.data.lookup.cannedNotes);
        }
        throw networkError;
    }
};

const CannedNotesQuery = gql`
    query CannedNotes (
        $actionTypeGuid: String
    ) {
        lookup {
            cannedNotes (
                actionTypeGuid: $actionTypeGuid
            ) {
                guid
                subject
                body
                actionTypeGuid
                actionTypeName
                sequence
                isActive
            }
        }
    }
`;
